import { Component, OnInit, ViewChild } from '@angular/core';
import { BannerAdsEmbedCodeDialogComponent } from '../banner-ads-embed-code-dialog/banner-ads-embed-code-dialog.component';
import { BannerSearchDto } from '../shared/dto/banner-search.dto';

@Component({
  selector: 'wl-banner-ad-search',
  templateUrl: './banner-ad-search.component.html',
  styleUrls: ['./banner-ad-search.component.less'],
    standalone: false
})
export class BannerAdSearchComponent implements OnInit {
  @ViewChild(BannerAdsEmbedCodeDialogComponent) private _embedCodeDialog: BannerAdsEmbedCodeDialogComponent;
  searchParams: BannerSearchDto;

  constructor() {
    this.searchParams = new BannerSearchDto();
  }

  ngOnInit(): void {}

  openEmbedCodeDialog() {
    this._embedCodeDialog.open();
  }
}
